import { Grid } from '@material-ui/core'

import styled from 'styled-components'

export const GridHeader = styled(Grid)`
  display: inline-flexbox;
  padding: 0.5rem 0 0.7rem 0;
`

export const GridTitle = styled(Grid)`
  display: block;
  padding: 0.5rem 0 1rem 0;
`

export const BoxTitle = styled.p`
  font-size: 1.8rem;
  color: ${({ theme }) => theme.colors.primary};
  font-weight: 600;
`

export const BoxLine = styled.p`
  width: 6.6rem;
  border-bottom: 4px solid ${({ theme }) => theme.colors.primary};
`
